import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import TabIcon from '@mui/icons-material/Tab';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { OrderItemContext, OrderItemEvent } from 'models/order-item-events';
import OrderStatusContextMenu from './order-status-context-menu.component';
import OrderOperationContextMenu from './order-operation-context-menu.component';

type OrderItemContextMenuProps = {
    orderContext?: OrderItemContext;
    onOrderItemEvent: (event: OrderItemEvent) => void;
    onCloseContextMenu: () => void;
};
const OrderItemContextMenu: FC<OrderItemContextMenuProps> = ({
    orderContext,
    onOrderItemEvent,
    onCloseContextMenu,
}: OrderItemContextMenuProps) => {
    const { t: translate } = useTranslation(['orders', 'workflow']);

    const navigateToOrderDetails = (newTab: boolean) => {
        const url = `/order-details/${orderContext?.order._id}/main-view`;
        if (newTab) {
            window.open(url, '_blank');
            return;
        } else {
            window.location.href = url;
        }
        onCloseContextMenu();
    };

    const copyOrderDetailsLink = () => {
        const url = `${window.location.origin}/order-details/${orderContext?.order._id}/main-view`;
        navigator.clipboard.writeText(url);
        onCloseContextMenu();
    };

    return (
        <Fragment>
            {orderContext ? (
                <Menu
                    open={orderContext !== null}
                    onClose={onCloseContextMenu}
                    anchorReference="anchorPosition"
                    anchorPosition={
                        orderContext !== null
                            ? { top: orderContext.mouseY + 5, left: orderContext.mouseX + 5 }
                            : undefined
                    }
                >
                    <MenuItem
                        onClick={() => {
                            navigateToOrderDetails(true);
                        }}
                    >
                        <ListItemIcon>
                            <TabIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>{translate('OPEN_ORDER_IN_NEW_TAB')}</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={copyOrderDetailsLink}>
                        <ListItemIcon>
                            <ContentCopyIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>{translate('COPY_LINK_TO_ORDER')}</ListItemText>
                    </MenuItem>

                    <Divider />

                    {!orderContext?.order?.isImportedOrder && (
                        <OrderStatusContextMenu onOrderItemEvent={onOrderItemEvent} order={orderContext?.order} />
                    )}
                    <OrderOperationContextMenu onOrderItemEvent={onOrderItemEvent} order={orderContext?.order} />
                </Menu>
            ) : undefined}
        </Fragment>
    );
};

export default OrderItemContextMenu;
